<template>
   <div>
        <v-row>
            <v-col cols="12" sm="6" md="4" xl="3">
                <Link  class="h-100" :href="route('billers.manage')">
                    <v-card class="h-100">
                        <v-card-text class="h-100 justify-center align-center d-flex">
                            <mdi-icon size="15">add_circle</mdi-icon>
                        </v-card-text>
                    </v-card>
                </Link>
            </v-col>
            <v-col cols="12" sm="6" md="4" xl="3" v-for="item in page.props.data?.billers">
                <v-card class="h-100">
                    <v-card-text>
                        <div class="w-100 h-10rem">
                            <img class="object-contain" :src="item.logo?.file_url" :alt="item.name">
                        </div>
                    </v-card-text>
                    <v-card-title>
                        <div class="d-flex ga-2">
                            <div class="flex-grow-1 min-w-0 text-truncate">{{ item.name }}</div>
                            <div class="flex-none">
                                <Link :href="route('billers.manage', item.id)">
                                    <v-btn-icon-text type="button" color="primary" density="compact">
                                        <mdi-icon>edit_square</mdi-icon>
                                    </v-btn-icon-text>
                                </Link>
                            </div>
                        </div>
                    </v-card-title>
                    <div class="pb-5"></div>
                </v-card>
            </v-col>
        </v-row>
   </div>
</template>
<script setup lang="ts">
    import { ref } from "vue";
    import { usePage, Link, useForm } from '@inertiajs/vue3';
    import { SharedPage, SharedPageProps } from '@/Types/inertia';
    import { pageTitle, containerGapForForm } from '@/Composables/PageMeta';
    import { Biller, TemplateVariable } from "@/Types/Models/biller";

    pageTitle.value = 'Billers';
    containerGapForForm();
    interface PageData extends SharedPageProps{
        data?:{
            billers?: Biller[],
        }
    }
    const page = usePage<PageData>();
</script>